module.exports = __webpack_public_path__ + "assets/img/1438.42b23941.svg";